import { Injector } from "@angular/core";
import moment from 'moment';
import { KpiService } from "../../../../dashboardCommon/services/kpiService";
import { DateRange } from "./dateRange";

class Range {
    public begin: string;
    public end: string;

    constructor(begin: string, end: string) {
        this.begin = begin;
        this.end = end;
    }
}

export abstract class OccupationalRiskPreventionKpiService<T> extends KpiService<T> {
    constructor(injector: Injector) {
        super(injector);
    }

    protected getDateRange(range: DateRange): Range {
        switch (range) {
            case DateRange.Inmediate: return this.getDayDates();
            case DateRange.CurrentWeek: return this.getWeekDates();
            default: throw new Error("Invalid date range");
        }
    }

    private getDayDates(): Range {
        let begin = moment();
        let formattedDate = "{0}{1}{2}".format(String(begin.year()).padStart(4, "0"), String(begin.month() + 1).padStart(2, "0"), String(begin.date()).padStart(2, "0"));
        return new Range(
            formattedDate,
            formattedDate
        );
    }

    private getWeekDates(): Range {
        let monday = moment().isoWeekday(1);
        let sunday = moment().isoWeekday(7);
        let beginFormatted = "{0}{1}{2}".format(String(monday.year()).padStart(4, "0"), String(monday.month() + 1).padStart(2, "0"), String(monday.date()).padStart(2, "0"));
        let endFormatted = "{0}{1}{2}".format(String(sunday.year()).padStart(4, "0"), String(sunday.month() + 1).padStart(2, "0"), String(sunday.date()).padStart(2, "0"));
        return new Range(beginFormatted, endFormatted);
    }
}
